import { CoreException, Response } from '@sdk/sdk';
import { McpClientRequest } from '../../auth';

export abstract class McpRequestsRepository {
  abstract get(serverOrigin: string, state: string): Promise<Response<McpClientRequest, CoreException>>;
}
